import Home from "./components/Home";
import Login from './components/Login';
import Signup from "./components/Signup";
import Article from "@/components/Article";
import Personal from "@/components/Personal";
import Overview from "@/components/Overview";
import Complete from "@/components/Complete";
import Suggest from "@/components/Suggest";
import Incomplete from "@/components/Incomplete";
import Type from "@/components/Type";
import Search from "@/components/Search";
import Nearby from "@/components/Nearby";
import PersonalUpdate from "@/components/PersonalUpdate";
import AppointmentNew from "@/components/AppointmentNew";
import CompleteGraph from "@/components/CompleteGraph";
import Appointment from "@/components/Appointment";
import Assist from "@/components/Assist";

export default [
    {path:'/', component: Home, meta:{title:'易苗'}},
    {path:'/login', component: Login, meta:{title:'登录'}},
    {path:'/signup', component: Signup, meta:{title:'注册'}},
    {path:'/article', component: Article, meta: {title: '文章'}},
    {path:'/personal', component: Personal, meta: {title: '个人中心'}},
    {path:'/overview', component: Overview, meta: {title: '接种概况'}},
    {path: '/complete', component: Complete, meta: {title: '已接种'}},
    {path: '/complete_graph', component: CompleteGraph, meta: {title: '接种图表'}},
    {path: '/suggest', component: Suggest, meta: {title: '建议接种'}},
    {path:'/incomplete', component: Incomplete, meta: {title: '未接种'}},
    {path: '/type', component: Type, meta: {title: '疫苗种类'}},
    {path:'/search', component: Search, meta: {title: '搜索'}},
    {path: '/nearby', component: Nearby, meta: {title: '附近医院'}},
    {path: '/update', component: PersonalUpdate, meta: {title: '修改个人资料'}},
    {path: '/appnew/:hospital', component: AppointmentNew, meta: {title: '新建预约'}},
    {path: '/appnewv/:vtid', component: AppointmentNew, meta: {title: '新建预约'}},
    {path: '/appointment', component: Appointment, meta: {title: '所有预约'}},
    {path: '/assist', component: Assist, meta: {title: '智能助手'}}
]